import React from "react";
import { useNavigate } from "react-router-dom";
import GridItem from "../../partials/gridItem";
import { serverUrl } from "../../config";

export default function PollItem(props) {
  const navigate = useNavigate();

  if (props.creator) {
    return (
      <GridItem
        xs={12}
        sm={6}
        lg={3}
        xl={3}
        xxl={2}
        itemClass="poll"
        item={props.item}
        bundle={props.item?.bundle}
        id={props.item?.id}
        title={props.item?.title}
        category_label={props.item?.category_labels}
        created={props.item.created}
        hasImg={true}
        imgSrc={`${serverUrl}${props.item.field_featured_image}`}
        cardActionArea={true}
        creator={props.creator}
        contentType={props.contentType}
        shareEnabled
        route={"polls"}
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the poll with your client, no login required.`}
      ></GridItem>
    );
  } else
    return (
      <GridItem
        xs={12}
        sm={6}
        md={3}
        itemClass="poll"
        item={props.item}
        bundle={props.item?.bundle}
        hasImg={true}
        id={props.item?.id}
        imgSrc={`${serverUrl}${props.item.field_featured_image}`}
        title={props.item?.title}
        field_body={props.item?.summary ?? ""}
        category_label={props.item?.category_labels}
        created={props.item.created}
        cardActionArea={true}
        // cardActionCallBack={() => {
        //   props.showPoll(props.item.id, props.item.question)
        // }}
        cardActionCallBack={() => navigate(`/polls/view/${props.item?.id}`)}
        contentType={props.contentType}
      ></GridItem>
    );
}
